var render = function (_h,_vm) {var _c=_vm._c;return _c('hr',{staticClass:"ctk-item-tracking-divider",class:{
    active: _vm.props.completed
  }})}
var staticRenderFns = []

export { render, staticRenderFns }